/**
 * @file save-states.ts
 * @description Какие признаки сохранения показать в панели, которая пишет две
 * части черновика сразу (phase19.16, партия Р3г; «Счётчики и cookie» —
 * COUNTERS и раздел темы `consentBanner`, часть THEME).
 *
 * Одна строка, пока всё хорошо: идущая запись важнее давно сохранённой,
 * из сохранённых — последняя. Беда (ошибка или конфликт) — у каждой части
 * своя строка со своим «Повторить» / «Обновить»: иначе вторая ошибка
 * пряталась бы за первой и правки той части терялись молча.
 */

import type { AutosaveApi } from "../../../hooks/site-view/useAutosavePart";

export type SaveState = Pick<AutosaveApi<unknown>, "status" | "savedAt" | "error" | "conflict" | "retry" | "reload">;

const isTrouble = (s: SaveState): boolean => s.status === "error" || s.status === "conflict";
const isBusy = (s: SaveState): boolean => s.status === "saving" || s.status === "pending";

export function saveStatesToShow(states: readonly SaveState[]): SaveState[] {
  const trouble = states.filter(isTrouble);
  if (trouble.length > 0) return trouble;
  const busy = states.find(isBusy);
  if (busy) return [busy];
  const latest = [...states].sort((a, b) => (b.savedAt?.getTime() ?? 0) - (a.savedAt?.getTime() ?? 0))[0];
  return latest ? [latest] : [];
}
